export default "__VITE_ASSET__VoYsSPMU__"